import { makeStyles } from '@material-ui/core/styles';

const CUE_GRADIENT = 'linear-gradient(0deg, #5F58E8 0%, #28C2F3 100%)';

export const useStyles = makeStyles(() => ({
  gradientBorder: {
    background: CUE_GRADIENT,
    borderRadius: 8,
    display: 'inline-flex',
    padding: 1,
  },
  gradientBorderFullWidth: {
    width: '100%',
  },
  innerButton: {
    borderRadius: 7,
  },
}));
